import { render } from "./App.vue?vue&type=template&id=75c89f90"
const script = {}

import "./App.vue?vue&type=style&index=0&id=75c89f90&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__